import { cn } from '@/shared/lib/utils';

/**
 * The Fincera mark — a graphite-ink chip with three ascending analytics bars
 * and an amber "spark" accent. Rendered as inline SVG so it stays crisp at any
 * size and always tracks the brand palette. Legible on any background.
 */
export function FinceraMark({ className }: { className?: string }) {
  return (
    <img
      src="/fincera-logo.png"
      alt="Fincera Logo"
      className={cn('h-16 w-auto max-w-full shrink-0 object-contain mx-auto scale-[2] mix-blend-multiply', className)}
    />
  );
}

/** The full Fincera lockup — the mark plus the "Fincera" wordmark. Real text so
 *  it stays sharp, accessible, and inherits the theme ink. */
export function FinceraWordmark({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center', className)}>
      <FinceraMark />
    </span>
  );
}

/** Full lockup — collapsed shows just the mark, expanded the full wordmark. */
export function FinceraLockup({ collapsed = false }: { collapsed?: boolean }) {
  return collapsed ? <FinceraMark className="h-8" /> : <FinceraWordmark />;
}
